import React, { useEffect, useRef, useState } from "react";
import { Button } from "@deere/isg.component-library";
import { SHA256 } from "crypto-js";

// const backendURI = '18.219.96.136/API';
const backendURI = process.env.REACT_APP_STRIPPED_BACKEND_URI;

// Matej.geojson content
const matejGeoJson = {
  type: "FeatureCollection",
  name: "worksite_250822_0",
  crs: {
    type: "name",
    properties: {
      name: "urn:ogc:def:crs:OGC:1.3:CRS84",
    },
  },
  features: [
    {
      type: "Feature",
      properties: {
        fid: 1,
        name: "path_mapping_recorder_02",
        layer: "reprojected_corridor_layer_local",
        path: "/home/dune/mapping_generation/250822_0900/reprojected_corridor_layer_local.gpkg",
        path_uuid: "{54b69444-a231-49b4-9aec-163c779dbabb}",
        type: "corridor",
        date_modified: null,
        uuid: "{a}",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [-121.52313800081897, 36.95367458319516],
              [-121.52313593412087, 36.95368147194249],
              [-121.52312986213566, 36.95368551576057],
              [-121.52293751420288, 36.95369459287144],
              [-121.5228618165015, 36.953699996087494],
              [-121.52243161853991, 36.95372354267435],
              [-121.52231556798988, 36.95373275462709],
              [-121.52217646415816, 36.95374593395532],
              [-121.52216914830089, 36.953744752123],
              [-121.52216340889372, 36.95373904045867],
              [-121.52215885593358, 36.953705097691476],
              [-121.52215994252116, 36.95369791839261],
              [-121.52216570459656, 36.9536936501419],
              [-121.5223040913249, 36.95367811091704],
              [-121.52252518351735, 36.953663003911394],
              [-121.52297751319236, 36.953637729077954],
              [-121.52299988678368, 36.95363597363063],
              [-121.52300229687869, 36.95363466572583],
              [-121.52307410930777, 36.95363428483417],
              [-121.52312610648767, 36.95363187448415],
              [-121.52313008145056, 36.95363278619113],
              [-121.52313504546326, 36.953636645485375],
              [-121.52313719942097, 36.95364073434793],
              [-121.52313800081897, 36.95367458319516],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        fid: 2,
        name: "path_mapping_recorder_01",
        layer: "reprojected_corridor_layer_local",
        path: "/home/dune/mapping_generation/250822_0900/reprojected_corridor_layer_local.gpkg",
        path_uuid: "{558f9f01-4f74-4463-91aa-4f3ae303a423}",
        type: "corridor",
        date_modified: null,
        uuid: "{b}",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [-121.52278018562488, 36.953688355741534],
              [-121.52277997004184, 36.95369140539605],
              [-121.52277484923106, 36.953698658481954],
              [-121.52277147746695, 36.953700432843654],
              [-121.52271713616604, 36.953701655509455],
              [-121.52263861853898, 36.953706542674425],
              [-121.52261988036634, 36.953708992210345],
              [-121.52256052756147, 36.95371155283808],
              [-121.52240543463238, 36.95372458190163],
              [-121.52217648178308, 36.95374693207973],
              [-121.5221699271555, 36.95374621973914],
              [-121.52216308798424, 36.95373916015207],
              [-121.52215789169645, 36.95370631053503],
              [-121.52215894737998, 36.95369790836851],
              [-121.52216548490573, 36.953693404979646],
              [-121.5222660807466, 36.95368357107348],
              [-121.5222885349588, 36.95368019909687],
              [-121.52242117535768, 36.95366871039727],
              [-121.52239123174047, 36.953646520310144],
              [-121.52236521318856, 36.95361863777269],
              [-121.5223420976169, 36.953583267957555],
              [-121.52232948457325, 36.95355818453173],
              [-121.52231716447353, 36.953525394835346],
              [-121.52228822503429, 36.953429564872096],
              [-121.52226202952563, 36.953325403606954],
              [-121.52226163607733, 36.95332265380438],
              [-121.5222652182291, 36.953316414521275],
              [-121.52231370586468, 36.953307179210746],
              [-121.52232120459006, 36.95330774106111],
              [-121.52232521063064, 36.9533104257783],
              [-121.52235616794026, 36.9534242606265],
              [-121.52236162833374, 36.95343406620769],
              [-121.52236786755417, 36.9534587987327],
              [-121.52237098269802, 36.95346308489773],
              [-121.52237644008224, 36.953482531385255],
              [-121.52237891608662, 36.95348471116226],
              [-121.52239690911314, 36.95353387933275],
              [-121.52240520065442, 36.953550181310206],
              [-121.52242872642452, 36.95358546874786],
              [-121.52244105464929, 36.95359864384213],
              [-121.52245686502323, 36.953611878292854],
              [-121.52248147994652, 36.95362719416136],
              [-121.52250191727842, 36.95363761582716],
              [-121.52252123176197, 36.95364458170638],
              [-121.52254963242045, 36.953650148475226],
              [-121.52258024914185, 36.95365246792379],
              [-121.52262009433304, 36.953652568229195],
              [-121.52263480056345, 36.953651660470044],
              [-121.52264199805008, 36.95364870710898],
              [-121.52271512585124, 36.95364814988941],
              [-121.52276710616997, 36.95364587451885],
              [-121.52277108042296, 36.9536467858477],
              [-121.52277786949315, 36.953653658599436],
              [-121.52278018562488, 36.953688355741534],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        fid: 3,
        name: "path_mapping_recorder_04",
        layer: "reprojected_corridor_layer_local",
        path: "/home/dune/mapping_generation/250822_0900/reprojected_corridor_layer_local.gpkg",
        path_uuid: "{b4f62e90-fb2d-4b58-afe5-2b83fdb0f7ae}",
        type: "corridor",
        date_modified: null,
        uuid: "{c}",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [-121.52346278243391, 36.95327168089992],
              [-121.52346223884403, 36.95327763922602],
              [-121.52345534255036, 36.95328333349539],
              [-121.52340986637769, 36.9532879930859],
              [-121.52340266223203, 36.95328725609404],
              [-121.52339842577982, 36.95328423618578],
              [-121.52337258741667, 36.95316385265989],
              [-121.52336657367547, 36.95314098367534],
              [-121.52336394048342, 36.953136604917034],
              [-121.5233613979661, 36.953123096025415],
              [-121.52335348461843, 36.95310718449641],
              [-121.5233470703056, 36.95308436513263],
              [-121.52333254557036, 36.9530529563149],
              [-121.52332328292627, 36.95304169354295],
              [-121.52331179170534, 36.953030490515815],
              [-121.5232830525504, 36.95301176604236],
              [-121.52325478483695, 36.95300288342513],
              [-121.52322805365107, 36.952999337352665],
              [-121.52319959313662, 36.9529980199064],
              [-121.52308505114974, 36.95300198044419],
              [-121.52294870943491, 36.953004019906395],
              [-121.5229108167486, 36.95300599607365],
              [-121.5228392704373, 36.95300601990638],
              [-121.52283511111175, 36.953008570122144],
              [-121.52276381674037, 36.953005019906385],
              [-121.5227118996327, 36.953005130303204],
              [-121.52270792621776, 36.953004219411845],
              [-121.52270102441298, 36.95299696763344],
              [-121.52270294460898, 36.952956912431475],
              [-121.52271156405975, 36.95295135540836],
              [-121.52287623753965, 36.95295198009356],
              [-121.52292118328575, 36.95295000392431],
              [-121.52297379554568, 36.95294985377536],
              [-121.52300172241748, 36.95294803838163],
              [-121.52305439550607, 36.95294795377615],
              [-121.52315318975924, 36.952944276634334],
              [-121.52322099969528, 36.95293898009354],
              [-121.52324981682924, 36.95293900393097],
              [-121.52327149165659, 36.95294120453677],
              [-121.52330832590035, 36.95294967495283],
              [-121.52332030189524, 36.95295404684692],
              [-121.52335406159219, 36.95297098257613],
              [-121.5233630190904, 36.95297868021706],
              [-121.52339181890545, 36.953008610625126],
              [-121.5234065153705, 36.953036815499644],
              [-121.52342470077966, 36.95308924005007],
              [-121.5234329966932, 36.953122137859275],
              [-121.52344391093412, 36.953169836758214],
              [-121.52346278243391, 36.95327168089992],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        fid: 4,
        name: "path_mapping_recorder_03",
        layer: "reprojected_corridor_layer_local",
        path: "/home/dune/mapping_generation/250822_0900/reprojected_corridor_layer_local.gpkg",
        path_uuid: "{9727fb90-b7b7-41ae-b8f7-d44099db925d}",
        type: "corridor",
        date_modified: null,
        uuid: "{d}",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [-121.52349393015825, 36.95350307044163],
              [-121.52348691991584, 36.95353913378314],
              [-121.52348128403383, 36.953551638328136],
              [-121.52346708028671, 36.95357798873329],
              [-121.52344192716728, 36.953609479996786],
              [-121.5234276184503, 36.95362163131159],
              [-121.52339841072538, 36.95364240861814],
              [-121.52338130179463, 36.95365095321589],
              [-121.5233571478773, 36.95366001810189],
              [-121.52331908253895, 36.95367086370986],
              [-121.52325170723354, 36.953679002032764],
              [-121.52301764711044, 36.95368899593254],
              [-121.52300523097425, 36.95368874471822],
              [-121.52299985311011, 36.95368621358282],
              [-121.52299664690408, 36.953682541191284],
              [-121.5229952886958, 36.95364218538169],
              [-121.52300222573388, 36.9536364815773],
              [-121.52304551331893, 36.953634728745946],
              [-121.52305632296273, 36.9536330806849],
              [-121.52315076607907, 36.95362975105162],
              [-121.52320969577048, 36.95362488761054],
              [-121.52327453945875, 36.95361716774204],
              [-121.523301206194, 36.95361126988615],
              [-121.52333090860363, 36.95360176862418],
              [-121.52336377553331, 36.953583376000864],
              [-121.52338381344438, 36.95356726684302],
              [-121.52338889073111, 36.95356142634648],
              [-121.52340272953018, 36.95354290910285],
              [-121.52341379624157, 36.953516690587875],
              [-121.52342086936125, 36.95348281797788],
              [-121.52342158214495, 36.95345599813731],
              [-121.52341899385912, 36.95342220740151],
              [-121.52341039573243, 36.953356011208946],
              [-121.52340180024966, 36.95330561845225],
              [-121.52339580909172, 36.953281925640105],
              [-121.52338918067053, 36.95322901550872],
              [-121.52338091587339, 36.95318643596132],
              [-121.52338226127331, 36.953179477232766],
              [-121.52338928656692, 36.95317478148183],
              [-121.523435, 36.95316998009387],
              [-121.52344344964631, 36.9531721042448],
              [-121.52344685100032, 36.95317664446566],
              [-121.52345335566562, 36.953210526925325],
              [-121.52345877485104, 36.95322842473905],
              [-121.52346172009217, 36.95325302920256],
              [-121.52346518273629, 36.95326609913884],
              [-121.5234842019915, 36.95338126992722],
              [-121.52348623266714, 36.95340507932719],
              [-121.52349422439138, 36.953454542343536],
              [-121.52349522797715, 36.95347539692146],
              [-121.52349393015825, 36.95350307044163],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        fid: 5,
        name: "path_mapping_recorder_00",
        layer: "reprojected_corridor_layer_local",
        path: "/home/dune/mapping_generation/250822_0900/reprojected_corridor_layer_local.gpkg",
        path_uuid: "{8990534f-cffe-4b51-b5d1-312f1dffe956}",
        type: "corridor",
        date_modified: null,
        uuid: "{e}",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [-121.52285899611324, 36.9529530345517],
              [-121.52286709472475, 36.9529539305929],
              [-121.5228720548031, 36.95295791159874],
              [-121.52287323805817, 36.95296310338397],
              [-121.52287171319522, 36.95299981008669],
              [-121.52286434162681, 36.953005642056006],
              [-121.52281788725972, 36.95300701945899],
              [-121.52255524016778, 36.953007019906394],
              [-121.52249257226777, 36.953010242718456],
              [-121.52244056215972, 36.9530175493493],
              [-121.52241180741522, 36.95302449780781],
              [-121.52238417308065, 36.95303515281176],
              [-121.52236247838553, 36.95304673238612],
              [-121.52234608967684, 36.95305832101095],
              [-121.5223247662133, 36.953080457012575],
              [-121.52231078127362, 36.95310078758857],
              [-121.5223032164425, 36.95311756178492],
              [-121.52229635107544, 36.95316060079542],
              [-121.52229815306845, 36.95318976113936],
              [-121.52230371040113, 36.95321125953891],
              [-121.52231255952734, 36.95326093567592],
              [-121.52232438514365, 36.95330755034682],
              [-121.522329490357, 36.953313744344314],
              [-121.52233970271425, 36.95337024077692],
              [-121.52235010470612, 36.95341183484924],
              [-121.52234290041709, 36.95341913233263],
              [-121.52229902172029, 36.95342586360859],
              [-121.52228946728803, 36.95342537028933],
              [-121.52228655032373, 36.95342389574675],
              [-121.52228318758283, 36.953419466322906],
              [-121.52227846698341, 36.95339573407741],
              [-121.52226212841371, 36.95333828723065],
              [-121.52223094798629, 36.9532117461237],
              [-121.52222588681487, 36.9531973449572],
              [-121.52222278366746, 36.95316657047901],
              [-121.5222227836737, 36.953141429488],
              [-121.52222597169494, 36.95311326234439],
              [-121.52223752407065, 36.953079733165126],
              [-121.52226620985124, 36.95303656982369],
              [-121.52229888685844, 36.95300775806711],
              [-121.52232772997317, 36.95299051425496],
              [-121.52234665779814, 36.952981064240724],
              [-121.52237695822299, 36.95296958355409],
              [-121.52240850830967, 36.95296220454284],
              [-121.52246111952611, 36.952955007795836],
              [-121.52254516048606, 36.952950981008264],
              [-121.52285899611324, 36.9529530345517],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        fid: 6,
        name: "path_mapping_recorder_01",
        layer: "reprojected_corridor_layer_local",
        path: "/home/dune/mapping_generation/250822_0900/reprojected_corridor_layer_local.gpkg",
        path_uuid: "{941b24c8-b90c-4914-b643-a91b32340e3c}",
        type: "corridor",
        date_modified: null,
        uuid: "{g}",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [-121.52278018562488, 36.953688355741534],
              [-121.52277997004184, 36.95369140539605],
              [-121.52277484923106, 36.953698658481954],
              [-121.52277147746695, 36.953700432843654],
              [-121.52271713616604, 36.953701655509455],
              [-121.52263861853898, 36.953706542674425],
              [-121.52261988036634, 36.953708992210345],
              [-121.52256052756147, 36.95371155283808],
              [-121.52240543463238, 36.95372458190163],
              [-121.52217648178308, 36.95374693207973],
              [-121.5221699271555, 36.95374621973914],
              [-121.52216308798424, 36.95373916015207],
              [-121.52215789169645, 36.95370631053503],
              [-121.52215894737998, 36.95369790836851],
              [-121.52216548490573, 36.953693404979646],
              [-121.5222660807466, 36.95368357107348],
              [-121.5222885349588, 36.95368019909687],
              [-121.52242117535768, 36.95366871039727],
              [-121.52239123174047, 36.953646520310144],
              [-121.52236521318856, 36.95361863777269],
              [-121.5223420976169, 36.953583267957555],
              [-121.52232948457325, 36.95355818453173],
              [-121.52231716447353, 36.953525394835346],
              [-121.52228822503429, 36.953429564872096],
              [-121.52226202952563, 36.953325403606954],
              [-121.52226163607733, 36.95332265380438],
              [-121.5222652182291, 36.953316414521275],
              [-121.52231370586468, 36.953307179210746],
              [-121.52232120459006, 36.95330774106111],
              [-121.52232521063064, 36.9533104257783],
              [-121.52235616794026, 36.9534242606265],
              [-121.52236162833374, 36.95343406620769],
              [-121.52236786755417, 36.9534587987327],
              [-121.52237098269802, 36.95346308489773],
              [-121.52237644008224, 36.953482531385255],
              [-121.52237891608662, 36.95348471116226],
              [-121.52239690911314, 36.95353387933275],
              [-121.52240520065442, 36.953550181310206],
              [-121.52242872642452, 36.95358546874786],
              [-121.52244105464929, 36.95359864384213],
              [-121.52245686502323, 36.953611878292854],
              [-121.52248147994652, 36.95362719416136],
              [-121.52250191727842, 36.95363761582716],
              [-121.52252123176197, 36.95364458170638],
              [-121.52254963242045, 36.953650148475226],
              [-121.52258024914185, 36.95365246792379],
              [-121.52262009433304, 36.953652568229195],
              [-121.52263480056345, 36.953651660470044],
              [-121.52264199805008, 36.95364870710898],
              [-121.52271512585124, 36.95364814988941],
              [-121.52276710616997, 36.95364587451885],
              [-121.52277108042296, 36.9536467858477],
              [-121.52277786949315, 36.953653658599436],
              [-121.52278018562488, 36.953688355741534],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        fid: 7,
        name: "loadzone",
        layer: "reprojected_zone_layer_local",
        path: "/home/dune/mapping_generation/250822_0900/reprojected_zone_layer_local.gpkg",
        path_uuid: null,
        type: "load",
        date_modified: "2025-08-22T16:09:47.789Z",
        uuid: "{f49342b0-af11-4a6d-8577-d016c025bdd5}",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [-121.52257387518694, 36.953176348357744],
              [-121.52247723170929, 36.952783991025576],
              [-121.52288300035441, 36.95278399099292],
              [-121.52310100094427, 36.952790991020976],
              [-121.52339700089989, 36.952807991018055],
              [-121.52347000174926, 36.95281599109816],
              [-121.52353200370824, 36.95283099149384],
              [-121.52359700589291, 36.95285699233001],
              [-121.52364400778478, 36.95288399350628],
              [-121.52371200893822, 36.95294599454599],
              [-121.52460100924458, 36.953893994884695],
              [-121.52463501088363, 36.95395799777477],
              [-121.52464601119502, 36.954007999312125],
              [-121.52464101107533, 36.95407100147972],
              [-121.52462300561386, 36.95412200823789],
              [-121.52458106641123, 36.95417591920506],
              [-121.52458199266665, 36.95417499317545],
              [-121.52458399244021, 36.954173993163316],
              [-121.52459199242833, 36.9541659933452],
              [-121.5245939924402, 36.95416499316332],
              [-121.52459699242833, 36.954161993345195],
              [-121.52459899094707, 36.95416099390988],
              [-121.5245999903681, 36.954158995368545],
              [-121.52460199242832, 36.95415699334521],
              [-121.52460399151592, 36.95415599362548],
              [-121.52460699036808, 36.95415099536854],
              [-121.5246139910382, 36.9541429945534],
              [-121.52461799020053, 36.95413999540303],
              [-121.52461899024529, 36.95413799553713],
              [-121.52462099036809, 36.954134995368534],
              [-121.52462399020052, 36.954131995403046],
              [-121.52462499024529, 36.95412999553714],
              [-121.52462600702755, 36.95412899297244],
              [-121.52462400963192, 36.95413200463146],
              [-121.52462100979949, 36.95413500459696],
              [-121.52461800963194, 36.954140004631455],
              [-121.52461400905293, 36.954143006090106],
              [-121.52460400845662, 36.954156005935275],
              [-121.5245990082475, 36.95416100613049],
              [-121.52459400757168, 36.95416500665479],
              [-121.5245920075598, 36.954166006836694],
              [-121.52458400757169, 36.954174006654796],
              [-121.52456700702191, 36.95418800703683],
              [-121.52456300755979, 36.9541900068367],
              [-121.52456001122773, 36.954194],
              [-121.52452700585162, 36.95421100774127],
              [-121.52447100240833, 36.954229008802876],
              [-121.524391001089, 36.95423800896853],
              [-121.52437783264484, 36.954237846421876],
              [-121.52321594446023, 36.95337994524248],
              [-121.52282158388824, 36.95339416453174],
              [-121.52277884014735, 36.953206421390064],
              [-121.52257387518694, 36.953176348357744],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        fid: 8,
        name: "dumpzone",
        layer: "reprojected_zone_layer_local",
        path: "/home/dune/mapping_generation/250822_0900/reprojected_zone_layer_local.gpkg",
        path_uuid: null,
        type: "dump",
        date_modified: "2025-08-22T16:10:38.643Z",
        uuid: "{3b7cece6-e862-4b8b-b75e-849ce5920253}",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [-121.52177919099395, 36.953059746500294],
              [-121.52277884014735, 36.953206421390064],
              [-121.52301940707116, 36.95426305013216],
              [-121.52283900035218, 36.95427100901836],
              [-121.52251300086891, 36.954279009010925],
              [-121.52230999989855, 36.95429000901169],
              [-121.52223399916684, 36.954290008986085],
              [-121.5222019972889, 36.954286008744354],
              [-121.52212899370166, 36.954262007460805],
              [-121.52210299296702, 36.9542460070243],
              [-121.52206599060533, 36.954212004934575],
              [-121.52203898908608, 36.95416400211598],
              [-121.52202798883549, 36.9541200009566],
              [-121.52202698881719, 36.95407399917923],
              [-121.52206598865241, 36.95391899988077],
              [-121.52207298837749, 36.953807],
              [-121.52207098838944, 36.95375300216514],
              [-121.52206398880503, 36.95372600068788],
              [-121.52206698850556, 36.95371199938478],
              [-121.52205198896716, 36.953624001768965],
              [-121.52200999044068, 36.95351900483707],
              [-121.52197399206621, 36.953485006894546],
              [-121.52193999211437, 36.95347000659813],
              [-121.52191599187037, 36.95345100627197],
              [-121.52191298982686, 36.953441004584484],
              [-121.52186799004446, 36.95339500416636],
              [-121.52185098934123, 36.95336100283196],
              [-121.52177919099395, 36.953059746500294],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        fid: 9,
        name: "waitzone",
        layer: "reprojected_zone_layer_local",
        path: "/home/dune/mapping_generation/250822_0900/reprojected_zone_layer_local.gpkg",
        path_uuid: null,
        type: "wait",
        date_modified: "2025-08-22T16:10:29.047Z",
        uuid: "{3ca12229-ed18-4cf9-8ce0-b6884e76f599}",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [-121.52282158388824, 36.95339416453174],
              [-121.52321594446023, 36.95337994524248],
              [-121.52437783264484, 36.954237846421876],
              [-121.52414799960931, 36.95423500920834],
              [-121.52369600083316, 36.954246008986075],
              [-121.5233150009915, 36.954250009010885],
              [-121.52301940707116, 36.95426305013216],
              [-121.52282158388824, 36.95339416453174],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        fid: 10,
        name: "lane0",
        layer: "reprojected_zone_layer_local",
        path: "/home/dune/mapping_generation/250822_0900/reprojected_zone_layer_local.gpkg",
        path_uuid: null,
        type: "lane",
        date_modified: "2025-08-22T16:10:04.058Z",
        uuid: "{e7326c89-9967-44c5-a8f1-5189d04cec15}",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [-121.52247723170929, 36.952783991025576],
              [-121.52257387518694, 36.953176348357744],
              [-121.52177919099395, 36.953059746500294],
              [-121.52175398885574, 36.95295400109818],
              [-121.52175598903774, 36.95290299805236],
              [-121.52176798977057, 36.95286499627886],
              [-121.52177899004457, 36.95284899583363],
              [-121.52181799297828, 36.95280899296314],
              [-121.52186999548869, 36.95278599174847],
              [-121.52192999910011, 36.95277499101806],
              [-121.52202900094427, 36.95277399102096],
              [-121.52245600099145, 36.95278399098912],
              [-121.52247723170929, 36.952783991025576],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        fid: 1,
        name: "dump1",
        layer: "path_resampled_path_mapping_recorder_01",
        path: "/home/dune/mapping_generation/250822_0900/path_resampled_path_mapping_recorder_01.gpkg.gpkg",
        type: "static",
        date_modified: null,
        uuid: "{558f9f01-4f74-4463-91aa-4f3ae303a423}",
        begin: "1",
        end: "21",
        bearing: null,
        start_uuid: "{3b7cece6-e862-4b8b-b75e-849ce5920253}",
        finish_uuid: null,
        containing_uuid: null,
      },
      geometry: {
        type: "LineString",
        coordinates: [
          [-121.522303, 36.953356],
          [-121.522315, 36.95339918743665],
          [-121.52232713764664, 36.953442412939886],
          [-121.52234150598358, 36.95348525897537],
          [-121.52235727328441, 36.953527273284436],
          [-121.52237599467774, 36.953566329785176],
          [-121.52240365870347, 36.95360498805522],
          [-121.52244026831195, 36.95363851220798],
          [-121.52248741402119, 36.95366180467373],
          [-121.52254001094927, 36.95367550273734],
          [-121.52259548632608, 36.953679],
          [-121.52265137623112, 36.953678],
          [-121.52268866961184, 36.953675330388165],
          [-121.52263438961646, 36.953679],
          [-121.52257924953919, 36.95368258348694],
          [-121.52252420852373, 36.953687],
          [-121.52246913560643, 36.9536912881312],
          [-121.52241416797092, 36.953696],
          [-121.52235937983903, 36.953701],
          [-121.52230494808752, 36.953707],
          [-121.52225087271607, 36.953712],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        fid: 2,
        name: "todump",
        layer: "path_resampled_path_mapping_recorder_00",
        path: "/home/dune/mapping_generation/250822_0900/path_resampled_path_mapping_recorder_00.gpkg.gpkg",
        type: "static",
        date_modified: null,
        uuid: "{8990534f-cffe-4b51-b5d1-312f1dffe956}",
        begin: "1",
        end: "17",
        bearing: null,
        start_uuid: "{f49342b0-af11-4a6d-8577-d016c025bdd5}",
        finish_uuid: "{3b7cece6-e862-4b8b-b75e-849ce5920253}",
        containing_uuid: "{e7326c89-9967-44c5-a8f1-5189d04cec15}",
      },
      geometry: {
        type: "LineString",
        coordinates: [
          [-121.522816, 36.952979],
          [-121.52276142819963, 36.95298],
          [-121.52270587641152, 36.9529792191029],
          [-121.52265059726773, 36.952979],
          [-121.52259445940832, 36.952979],
          [-121.52253851112069, 36.95298],
          [-121.52248343890298, 36.952983],
          [-121.52242919749834, 36.95299145062544],
          [-121.52237686852563, 36.95300671049147],
          [-121.52233116342013, 36.953031836579875],
          [-121.52229505616548, 36.95306541575183],
          [-121.52227332052448, 36.95310603842667],
          [-121.522264, 36.95315010961251],
          [-121.522266, 36.95319474209979],
          [-121.522273993037, 36.95323897911102],
          [-121.52228348794614, 36.953282463838484],
          [-121.52229444306565, 36.9533256708031],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        fid: 3,
        name: "toload",
        layer: "path_resampled_path_mapping_recorder_03",
        path: "/home/dune/mapping_generation/250822_0900/path_resampled_path_mapping_recorder_03.gpkg.gpkg",
        type: "static",
        date_modified: null,
        uuid: "{9727fb90-b7b7-41ae-b8f7-d44099db925d}",
        begin: "1",
        end: "16",
        bearing: null,
        start_uuid: "{3ca12229-ed18-4cf9-8ce0-b6884e76f599}",
        finish_uuid: "{f49342b0-af11-4a6d-8577-d016c025bdd5}",
        containing_uuid: null,
      },
      geometry: {
        type: "LineString",
        coordinates: [
          [-121.523052, 36.953661],
          [-121.52310631540448, 36.953658],
          [-121.52316211127008, 36.953656],
          [-121.52321759459078, 36.95365235135232],
          [-121.52327258520044, 36.953646103699896],
          [-121.52332617253704, 36.953633913731515],
          [-121.52337496025407, 36.95361235983065],
          [-121.5234136692958, 36.953580330704234],
          [-121.52343999059964, 36.95354101410054],
          [-121.52345235795235, 36.953497568190656],
          [-121.52345400484629, 36.95345301453893],
          [-121.523451, 36.95340878115787],
          [-121.52344552105916, 36.95336456317751],
          [-121.523438, 36.95332019904038],
          [-121.523431, 36.95327618235091],
          [-121.52342329297862, 36.95324],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        fid: 4,
        name: "towait",
        layer: "path_resampled_path_mapping_recorder_02",
        path: "/home/dune/mapping_generation/250822_0900/path_resampled_path_mapping_recorder_02.gpkg.gpkg",
        type: "static",
        date_modified: null,
        uuid: "{54b69444-a231-49b4-9aec-163c779dbabb}",
        begin: "1",
        end: "16",
        bearing: null,
        start_uuid: "{3b7cece6-e862-4b8b-b75e-849ce5920253}",
        finish_uuid: "{3ca12229-ed18-4cf9-8ce0-b6884e76f599}",
        containing_uuid: null,
      },
      geometry: {
        type: "LineString",
        coordinates: [
          [-121.522217, 36.953715],
          [-121.52227024360351, 36.95371],
          [-121.5223248911888, 36.953704],
          [-121.52238009459913, 36.9537],
          [-121.52243513242514, 36.95369662252496],
          [-121.52249016825398, 36.953693],
          [-121.52254573790908, 36.95369],
          [-121.52260062105027, 36.953686],
          [-121.52265581154963, 36.953683],
          [-121.52271131869949, 36.95367967032514],
          [-121.52276657169242, 36.953677],
          [-121.52282214133618, 36.953674],
          [-121.52287755806158, 36.95367],
          [-121.52293312770074, 36.953667],
          [-121.52298874530429, 36.95366456367395],
          [-121.52304340378477, 36.953662],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        fid: 5,
        name: "loadpath",
        layer: "path_resampled_path_mapping_recorder_04",
        path: "/home/dune/mapping_generation/250822_0900/path_resampled_path_mapping_recorder_04.gpkg.gpkg",
        type: "static",
        date_modified: null,
        uuid: "{b4f62e90-fb2d-4b58-afe5-2b83fdb0f7ae}",
        begin: "1",
        end: "16",
        bearing: null,
        start_uuid: "{f49342b0-af11-4a6d-8577-d016c025bdd5}",
        finish_uuid: null,
        containing_uuid: null,
      },
      geometry: {
        type: "LineString",
        coordinates: [
          [-121.523424, 36.953241],
          [-121.52341535286081, 36.95319905858244],
          [-121.52340566485417, 36.953155497281266],
          [-121.52339341160993, 36.95311223482979],
          [-121.52337806785683, 36.95306913571366],
          [-121.52335468173638, 36.95302868173638],
          [-121.52331620845914, 36.95299680563944],
          [-121.52326597520609, 36.95297832506872],
          [-121.52321127794312, 36.95297206948578],
          [-121.52315559129715, 36.952972],
          [-121.52309983258651, 36.952974],
          [-121.52304388430264, 36.952975],
          [-121.52298793601778, 36.952976],
          [-121.52293217730418, 36.952978],
          [-121.52287622901748, 36.952979],
          [-121.52282009115808, 36.952979],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        fid: 6,
        name: "dump2",
        layer: "path_resampled_path_mapping_recorder_01",
        path: "/home/dune/mapping_generation/250822_0900/path_resampled_path_mapping_recorder_01.gpkg.gpkg",
        type: "static",
        date_modified: null,
        uuid: "{941b24c8-b90c-4914-b643-a91b32340e3c}",
        begin: "1",
        end: "21",
        bearing: null,
        start_uuid: "{3b7cece6-e862-4b8b-b75e-849ce5920253}",
        finish_uuid: null,
        containing_uuid: null,
      },
      geometry: {
        type: "LineString",
        coordinates: [
          [-121.522303, 36.953356],
          [-121.522315, 36.95339918743665],
          [-121.52232713764664, 36.953442412939886],
          [-121.52234150598358, 36.95348525897537],
          [-121.52235727328441, 36.953527273284436],
          [-121.52237599467774, 36.953566329785176],
          [-121.52240365870347, 36.95360498805522],
          [-121.52244026831195, 36.95363851220798],
          [-121.52248741402119, 36.95366180467373],
          [-121.52254001094927, 36.95367550273734],
          [-121.52259548632608, 36.953679],
          [-121.52265137623112, 36.953678],
          [-121.52268866961184, 36.953675330388165],
          [-121.52263438961646, 36.953679],
          [-121.52257924953919, 36.95368258348694],
          [-121.52252420852373, 36.953687],
          [-121.52246913560643, 36.9536912881312],
          [-121.52241416797092, 36.953696],
          [-121.52235937983903, 36.953701],
          [-121.52230494808752, 36.953707],
        ],
      },
    },
  ],
  worksite_version: "6.2",
  worksite_reference_latitude: 36.952774,
  worksite_reference_longitude: -121.524646,
};

// Example Mission Structure
const exampleMission = {
  missionId: "Mission 001",
  missionName: "E2E Test Mission",
  missionType: "Test",
  missionDescription: "Automated E2E Test Mission",
  taskRepetitions: "1",
  vehicleID: "Dusty",
  tasks: [
    {
      title: "towait",
      action: "Navigate",
      properties: {
        uuid: "{54b69444-a231-49b4-9aec-163c779dbabb}",
      },
    },
    {
      title: "Wait to Enter",
      action: "Command",
      properties: {
        workType: "WaitToEnter",
      },
    },
    {
      title: "toload",
      action: "Navigate",
      properties: {
        uuid: "{9727fb90-b7b7-41ae-b8f7-d44099db925d}",
      },
    },
    {
      title: "Load Truck",
      action: "Command",
      properties: {
        workType: "GetLoaded",
      },
    },
    {
      title: "loadpath",
      action: "Navigate",
      properties: {
        uuid: "{b4f62e90-fb2d-4b58-afe5-2b83fdb0f7ae}",
      },
    },
    {
      title: "Dump",
      action: "Command",
      properties: {
        workType: "RasieAndLowerBin",
      },
    },
    {
      title: "todump",
      action: "Navigate",
      properties: {
        uuid: "{8990534f-cffe-4b51-b5d1-312f1dffe956}",
      },
    },
  ],
};

interface EndToEndTestProps {
  fullMQTT: any;
  setOrgName: (newOrgName: string) => void;
}

const TARGET_ORG = "OrchTest";
const TARGET_JOBSITE = "JobTest";
const TARGET_SESSION = "SesTest";
const TARGET_TOPIC_PREFIX = `${TARGET_ORG}/${TARGET_JOBSITE}/${TARGET_SESSION}/`;
const MACHINE_TOPIC_PORTION = "ADT_460_test1";
const MACHINE_SESSION_KEY = "ADT_460_test1";

const EndToEndTest: React.FC<EndToEndTestProps> = ({ fullMQTT, setOrgName }) => {
  const [testStatus, setTestStatus] = useState<"IDLE" | "RUNNING" | "PASS" | "FAIL">("IDLE");
  const [logs, setLogs] = useState<string[]>([]);
  const [results, setResults] = useState<
    { step: string; latency: number; status: "PASS" | "FAIL" }[]
  >([]);
  const fullMQTTRef = useRef<any>(fullMQTT);

  useEffect(() => {
    fullMQTTRef.current = fullMQTT;
  }, [fullMQTT]);

  const log = (message: string) => {
    setLogs((prev) => [...prev, `${new Date().toLocaleTimeString()}: ${message}`]);
  };

  const sanitizeName = (name?: string, fallbackPrefix: string = "Nameless"): string => {
    if (!name) {
      return `${fallbackPrefix} ${Math.floor(Math.random() * 99999999).toString()}`;
    }
    return name.replace(/_/g, " ").replace(/[^a-zA-Z0-9 ]/g, "");
  };

  const getSessionData = () => {
    const mqttData = fullMQTTRef.current;
    const orgLevel = mqttData?.[TARGET_ORG] ?? mqttData;
    const jobsiteLevel = orgLevel?.[TARGET_JOBSITE];
    const sessionLevel = jobsiteLevel?.[TARGET_SESSION];
    return sessionLevel;
  };

  const waitFor = async (
    predicate: () => boolean,
    timeoutMs: number,
    intervalMs: number = 500,
  ): Promise<boolean> => {
    const start = Date.now();
    while (Date.now() - start < timeoutMs) {
      if (predicate()) {
        return true;
      }
      await new Promise((resolve) => setTimeout(resolve, intervalMs));
    }
    return false;
  };

  const findMissionsObject = (obj: any): any | null => {
    if (obj && typeof obj === "object") {
      if ("Missions" in obj) {
        return obj.Missions;
      }

      for (const key in obj) {
        const result = findMissionsObject(obj[key]);
        if (result) {
          return result;
        }
      }
    }

    return null;
  };

  const findMachineObject = (obj: any): any | null => {
    if (!obj || typeof obj !== "object") {
      return null;
    }

    if (obj[MACHINE_SESSION_KEY]) {
      return obj[MACHINE_SESSION_KEY];
    }

    for (const key in obj) {
      const value = obj[key];
      if (value && typeof value === "object") {
        const nested = findMachineObject(value);
        if (nested) {
          return nested;
        }
      }
    }

    return null;
  };

  const getMachineState = (machineObj: any) => {
    const autonomyCode = machineObj?.VADC?.autonomy?.state?.[0];
    const autonomyRaw =
      machineObj?.VADC_autonomy_state?.state ??
      machineObj?.VADC_autonomy_state?.["state"] ??
      machineObj?.VADC_autonomy_state?.["0"];

    const navigatorRaw =
      machineObj?.Navigator?.NavigatorState?.state ??
      machineObj?.NavigatorState?.state ??
      machineObj?.navigatorState;

    const autonomyState =
      autonomyCode === 2 ||
      autonomyRaw === 2 ||
      autonomyRaw === "2" ||
      autonomyRaw === "ACTIVE" ||
      autonomyRaw === "Active"
        ? "Active"
        : "Other";

    const navigatorState =
      navigatorRaw === "INTERRUPTED" || navigatorRaw === "Interrupted"
        ? "Interrupted"
        : "NotInterrupted";

    return { autonomyState, navigatorState, autonomyCode, autonomyRaw, navigatorRaw };
  };

  const runTest = async () => {
    setTestStatus("RUNNING");
    setLogs([]);
    setResults([]);

    try {
      setOrgName(TARGET_ORG);

      log("Starting Step 1: Publish GeoJSON exactly like uploadGeoJSON()...");
      const geoJsonStartTime = performance.now();

      const blob = new Blob([JSON.stringify(matejGeoJson, null, 4)], {
        type: "application/geo+json",
      });
      const file = new File([blob], "matej.geojson", { type: "application/geo+json" });
      const geojsonString = await new Promise<string>((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => {
          if (e.target == null) {
            reject(new Error("Error reading file."));
            return;
          }
          resolve(e.target.result as string);
        };
        reader.onerror = () => reject(new Error("Error reading file."));
        reader.readAsText(file);
      });

      console.log("geojsonString", geojsonString);

      const parsedGeojson = JSON.parse(geojsonString);
      const checksumString = SHA256(geojsonString).toString();
      const racfidString = "GUEST";

      const geojsonResponse = await fetch("/API/Save/GeoJSON2", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          geojsonString,
          currentTopicString: TARGET_TOPIC_PREFIX + "Worksite",
          checksumString,
          racfidString,
        }),
      });

      if (!geojsonResponse.ok) {
        throw new Error(`GeoJSON2 publish failed: ${geojsonResponse.statusText}`);
      }

      const expectedShapes: { name: string; pointsCount: number }[] = [];
      const expectedLines: { name: string; pointsCount: number }[] = [];
      const expectedPoints: { name: string; lat: number; lng: number }[] = [];

      const publishShape = async (
        pointsArray: any,
        pointsName: string,
        pointsUUID: string,
        pointsDescription: string,
        pointsType: string,
      ) => {
        const response = await fetch(`https://${backendURI}/Save/BoundaryNew`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            name: pointsName,
            uuid: pointsUUID,
            description: pointsDescription,
            zoneType:
              {
                FREE_SPACE_ZONE: 0,
                RESTRICTED_ZONE: 1,
                BOUNDARY: 2,
                OI_OBJECT: 3,
                WORK_ZONE: 4,
                NAVIGABLE_PATH: 0,
                WINDROW: 1,
                STATIC_ROUTE: 2,
                DUMP_POINT: 0,
                LOAD_POINT: 1,
              }[pointsType] ?? 0,
            pointsArray,
            deleted: false,
            currentTopicString: TARGET_TOPIC_PREFIX + "Shape/" + pointsName,
          }),
        });

        if (!response.ok) {
          throw new Error(`BoundaryNew publish failed for ${pointsName}`);
        }
      };

      const publishLine = async (
        pointsArray: any,
        pointsName: string,
        pointsUUID: string,
        pointsDescription: string,
        pointsType: string,
      ) => {
        const response = await fetch(`https://${backendURI}/Save/LineNew`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            name: pointsName,
            uuid: pointsUUID,
            description: pointsDescription,
            zoneType:
              {
                FREE_SPACE_ZONE: 0,
                RESTRICTED_ZONE: 1,
                BOUNDARY: 2,
                OI_OBJECT: 3,
                WORK_ZONE: 4,
                NAVIGABLE_PATH: 0,
                WINDROW: 1,
                STATIC_ROUTE: 2,
                DUMP_POINT: 0,
                LOAD_POINT: 1,
              }[pointsType] ?? 0,
            pointsArray,
            deleted: false,
            currentTopicString: TARGET_TOPIC_PREFIX + "Line/" + pointsName,
          }),
        });

        if (!response.ok) {
          throw new Error(`LineNew publish failed for ${pointsName}`);
        }
      };

      const publishPoint = async (
        lat: any,
        lng: any,
        pointsName: string,
        pointsUUID: string,
        pointsDescription: string,
        pointsType: string,
        approachHeading: any,
      ) => {
        const response = await fetch(`https://${backendURI}/Save/PointNew`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            name: pointsName,
            uuid: pointsUUID,
            lat,
            lng,
            description: pointsDescription,
            pointType:
              {
                FREE_SPACE_ZONE: 0,
                RESTRICTED_ZONE: 1,
                BOUNDARY: 2,
                OI_OBJECT: 3,
                WORK_ZONE: 4,
                NAVIGABLE_PATH: 0,
                WINDROW: 1,
                STATIC_ROUTE: 2,
                DUMP_POINT: 0,
                LOAD_POINT: 1,
              }[pointsType] ?? 0,
            currentTopicString: TARGET_TOPIC_PREFIX + "Point/" + pointsName,
            deleted: false,
            heading: approachHeading,
          }),
        });

        if (!response.ok) {
          throw new Error(`PointNew publish failed for ${pointsName}`);
        }
      };

      if (
        (parsedGeojson?.features || false) &&
        (parsedGeojson?.features?.length || false) &&
        parsedGeojson.features.length > 0
      ) {
        for (const thisFeature of parsedGeojson.features) {
          if (thisFeature.geometry?.type == "Polygon") {
            if (thisFeature.properties?.type === "Corridor") {
            } else {
              let polygonPoints: any = [];
              (thisFeature.geometry?.coordinates[0] as any).map((coordinate: any) => {
                polygonPoints.push({ lat: coordinate[1], lng: coordinate[0] });
              });
              let entityType =
                thisFeature.properties?.type ||
                thisFeature.properties?.boundarytype ||
                "FREE_SPACE_ZONE";
              const sanitizedName = sanitizeName(thisFeature.properties?.name, "Nameless Polygon");
              await publishShape(
                polygonPoints,
                sanitizedName,
                thisFeature.properties?.uuid || null,
                thisFeature.properties?.description || "Description Goes Here",
                entityType,
              );
              expectedShapes.push({ name: sanitizedName, pointsCount: polygonPoints.length });
            }
          } else if (thisFeature.geometry?.type == "LineString") {
            let linePoints: any = [];
            (thisFeature.geometry?.coordinates as any).map((coordinate: any) => {
              linePoints.push({ lat: coordinate[1], lng: coordinate[0] });
            });
            let entityType =
              thisFeature.properties?.type ||
              thisFeature.properties?.boundarytype ||
              "STATIC_ROUTE";
            const sanitizedName = sanitizeName(thisFeature.properties?.name, "Nameless Line");
            await publishLine(
              linePoints,
              sanitizedName,
              thisFeature.properties?.uuid || null,
              thisFeature.properties?.description || "Description Goes Here",
              entityType,
            );
            expectedLines.push({ name: sanitizedName, pointsCount: linePoints.length });
          } else if (thisFeature.geometry?.type == "Point") {
            let entityType =
              thisFeature.properties?.type || thisFeature.properties?.boundarytype || "DUMP_POINT";
            const sanitizedName = sanitizeName(thisFeature.properties?.name, "Nameless Point");
            const lat = thisFeature.geometry?.coordinates[1] || 0;
            const lng = thisFeature.geometry?.coordinates[0] || 0;
            await publishPoint(
              lat,
              lng,
              sanitizedName,
              thisFeature.properties?.uuid || null,
              thisFeature.properties?.description || "Description Goes Here",
              entityType,
              thisFeature.properties?.approachHeading || 0,
            );
            expectedPoints.push({ name: sanitizedName, lat, lng });
          } else if (thisFeature.geometry?.type == "MultiPoint") {
            let entityType =
              thisFeature.properties?.type || thisFeature.properties?.boundarytype || "DUMP_POINT";
            const sanitizedName = sanitizeName(thisFeature.properties?.name, "Nameless Point");
            const lat = thisFeature.geometry?.coordinates[0][1] || 0;
            const lng = thisFeature.geometry?.coordinates[0][0] || 0;
            await publishPoint(
              lat,
              lng,
              sanitizedName,
              thisFeature.properties?.uuid || null,
              thisFeature.properties?.description || "Description Goes Here",
              entityType,
              thisFeature.properties?.approachHeading || 0,
            );
            expectedPoints.push({ name: sanitizedName, lat, lng });
          } else if (thisFeature.geometry?.type == "MultiPolygon") {
            if (thisFeature.properties?.type === "Corridor") {
            } else {
              let polygonPoints: any = [];
              (thisFeature.geometry?.coordinates[0][0] as any).map((coordinate: any) => {
                polygonPoints.push({ lat: coordinate[1], lng: coordinate[0] });
              });
              let entityType =
                thisFeature.properties?.type ||
                thisFeature.properties?.boundarytype ||
                "FREE_SPACE_ZONE";
              const sanitizedName = sanitizeName(thisFeature.properties?.name, "Nameless Polygon");
              await publishShape(
                polygonPoints,
                sanitizedName,
                thisFeature.properties?.uuid || null,
                thisFeature.properties?.description || "Description Goes Here",
                entityType,
              );
              expectedShapes.push({ name: sanitizedName, pointsCount: polygonPoints.length });
            }
          } else if (thisFeature.geometry?.type == "MultiLineString") {
            let linePoints: any = [];
            (thisFeature.geometry?.coordinates[0] as any).map((coordinate: any) => {
              linePoints.push({ lat: coordinate[1], lng: coordinate[0] });
            });
            let entityType =
              thisFeature.properties?.type ||
              thisFeature.properties?.boundarytype ||
              "STATIC_ROUTE";
            const sanitizedName = sanitizeName(thisFeature.properties?.name, "Nameless Line");
            await publishLine(
              linePoints,
              sanitizedName,
              thisFeature.properties?.uuid || null,
              thisFeature.properties?.description || "Description Goes Here",
              entityType,
            );
            expectedLines.push({ name: sanitizedName, pointsCount: linePoints.length });
          }
        }
      } else {
        throw new Error("GeoJSON has no Features.");
      }

      const geoJsonEndTime = performance.now();
      const geoJsonLatency = geoJsonEndTime - geoJsonStartTime;
      log(`Step 1 Complete. Latency: ${geoJsonLatency.toFixed(2)}ms`);
      setResults((prev) => [
        ...prev,
        {
          step: "Publish GeoJSON (GeoJSON2 + Shape/Line/Point)",
          latency: geoJsonLatency,
          status: "PASS",
        },
      ]);

      log("Starting Step 2: Verify published data in subscribed session object...");
      const verificationStart = performance.now();

      const verificationSuccess = await waitFor(
        () => {
          const sessionData = getSessionData();
          if (!sessionData) {
            return false;
          }

          const shapeContainer = sessionData.Shape ?? sessionData.Shapes ?? {};
          const lineContainer = sessionData.Line ?? sessionData.Lines ?? {};
          const pointContainer = sessionData.Point ?? sessionData.Points ?? {};
          const worksiteObj = sessionData.Worksite;

          const worksiteGeojson = worksiteObj?.geojson || worksiteObj?.geoJson || "";
          if (!worksiteGeojson || worksiteGeojson !== geojsonString) {
            return false;
          }

          const shapesOk = expectedShapes.every((shapeEntry) => {
            const published = shapeContainer?.[shapeEntry.name];
            return (
              published &&
              Array.isArray(published.points) &&
              published.points.length === shapeEntry.pointsCount
            );
          });

          const linesOk = expectedLines.every((lineEntry) => {
            const published = lineContainer?.[lineEntry.name];
            return (
              published &&
              Array.isArray(published.points) &&
              published.points.length === lineEntry.pointsCount
            );
          });

          const pointsOk = expectedPoints.every((pointEntry) => {
            const published = pointContainer?.[pointEntry.name];
            if (!published || !published.location) {
              return false;
            }
            const latDelta = Math.abs((published.location.latitude ?? 0) - pointEntry.lat);
            const lngDelta = Math.abs((published.location.longitude ?? 0) - pointEntry.lng);
            return latDelta < 0.000001 && lngDelta < 0.000001;
          });

          return shapesOk && linesOk && pointsOk;
        },
        30000,
        500,
      );

      const verificationLatency = performance.now() - verificationStart;

      if (!verificationSuccess) {
        const sessionData = getSessionData();
        log(
          `Verification failed for session path ${TARGET_ORG}/${TARGET_JOBSITE}/${TARGET_SESSION}`,
        );
        log(`Session data present: ${sessionData ? "yes" : "no"}`);
        throw new Error("Published data verification failed in subscribed org data session.");
      }

      log(`Step 2 Complete. Latency: ${verificationLatency.toFixed(2)}ms`);
      setResults((prev) => [
        ...prev,
        {
          step: "Verify Shapes/Lines/Points/Worksite in subscribed session",
          latency: verificationLatency,
          status: "PASS",
        },
      ]);

      log("Starting Step 3: Create Mission Object...");
      const missionObject = {
        ...exampleMission,
        missionId: `Mission ${Math.floor(Math.random() * 99999999).toString()}`,
        missionName: `E2E Test Mission ${Math.floor(Date.now() / 1000)}`,
        missionDescription: `Automated E2E mission test ${new Date().toISOString()}`,
      };
      log("Step 3 Complete. Mission Object Created.");

      log("Starting Step 4: Save Mission...");
      const saveMissionStartTime = performance.now();

      const currentTopicString =
        TARGET_TOPIC_PREFIX + "SiteManager/1/1/Missions/" + missionObject.missionId;
      const cleanTasks = (missionObject.tasks || []).map((task: any) => {
        const { icon, ...rest } = task;
        return rest;
      });

      const saveResponse = await fetch(`https://${backendURI}/Save/Mission`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          missionObject: {
            ...missionObject,
            tasks: cleanTasks,
          },
          currentTopicString: currentTopicString,
        }),
      });

      const saveMissionEndTime = performance.now();
      const saveMissionLatency = saveMissionEndTime - saveMissionStartTime;

      if (!saveResponse.ok) {
        throw new Error(`Save Mission failed: ${saveResponse.statusText}`);
      }

      log(`Step 4 Complete. Latency: ${saveMissionLatency.toFixed(2)}ms`);
      setResults((prev) => [
        ...prev,
        { step: "Save Mission", latency: saveMissionLatency, status: "PASS" },
      ]);

      log("Starting Step 5: Verify mission is readable in org data session...");
      const missionVerifyStart = performance.now();

      const missionVisible = await waitFor(
        () => {
          const sessionData = getSessionData();
          if (!sessionData) {
            return false;
          }

          const missions = findMissionsObject(sessionData);
          const missionFromSession = missions?.[missionObject.missionId];
          if (!missionFromSession) {
            return false;
          }

          return (
            missionFromSession?.missionId === missionObject.missionId &&
            missionFromSession?.missionName === missionObject.missionName &&
            missionFromSession?.missionDescription === missionObject.missionDescription &&
            Array.isArray(missionFromSession?.tasks)
          );
        },
        30000,
        500,
      );

      const missionVerifyLatency = performance.now() - missionVerifyStart;

      if (!missionVisible) {
        throw new Error(
          "Mission save succeeded but mission was not readable from session Missions data.",
        );
      }

      log(`Step 5 Complete. Latency: ${missionVerifyLatency.toFixed(2)}ms`);
      setResults((prev) => [
        ...prev,
        {
          step: "Verify mission readable in session Missions",
          latency: missionVerifyLatency,
          status: "PASS",
        },
      ]);

      log("Starting Step 6: Send machine mission (RightNow publishMission style)...");
      const machineMissionStart = performance.now();

      const machineMissionResponse = await fetch("/API/Save/AddMissionNew2", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          mission: {
            ...missionObject,
            tasks: cleanTasks,
          },
          currentTopicString:
            TARGET_TOPIC_PREFIX +
            "SiteManager/Orchestrator/TaskList/" +
            MACHINE_TOPIC_PORTION.replace(/\//g, "_"),
          machineTopic: TARGET_TOPIC_PREFIX + MACHINE_TOPIC_PORTION,
        }),
      });

      const machineMissionLatency = performance.now() - machineMissionStart;
      if (!machineMissionResponse.ok) {
        throw new Error(`Machine mission publish failed: ${machineMissionResponse.statusText}`);
      }

      log(`Step 6 Complete. Latency: ${machineMissionLatency.toFixed(2)}ms`);
      setResults((prev) => [
        ...prev,
        { step: "Send machine mission task list", latency: machineMissionLatency, status: "PASS" },
      ]);

      log("Starting Step 7: Verify machine becomes Active and not Interrupted...");
      const machineStateStart = performance.now();

      const machineStateOk = await waitFor(
        () => {
          const sessionData = getSessionData();
          const machineObj = findMachineObject(sessionData);
          if (!machineObj) {
            return false;
          }

          const machineState = getMachineState(machineObj);
          return (
            machineState.autonomyState === "Active" && machineState.navigatorState !== "Interrupted"
          );
        },
        60000,
        1000,
      );

      const machineStateLatency = performance.now() - machineStateStart;
      if (!machineStateOk) {
        const sessionData = getSessionData();
        const machineObj = findMachineObject(sessionData);
        const machineState = getMachineState(machineObj);
        log(`Machine state check failed for key ${MACHINE_SESSION_KEY}`);
        log(
          `autonomyState=${machineState.autonomyState}, navigatorState=${machineState.navigatorState}`,
        );
        log(
          `autonomyCode=${machineState.autonomyCode}, autonomyRaw=${machineState.autonomyRaw}, navigatorRaw=${machineState.navigatorRaw}`,
        );
        throw new Error(
          "Machine did not reach Active autonomy state with navigator not Interrupted.",
        );
      }

      log(`Step 7 Complete. Latency: ${machineStateLatency.toFixed(2)}ms`);
      setResults((prev) => [
        ...prev,
        {
          step: "Verify machine Active autonomy state",
          latency: machineStateLatency,
          status: "PASS",
        },
      ]);

      setTestStatus("PASS");
    } catch (error: any) {
      log(`Test Failed: ${error.message}`);
      setTestStatus("FAIL");
    }
  };

  return (
    <div
      style={{ padding: "20px", marginTop: "20px", border: "1px solid #ddd", borderRadius: "4px" }}
    >
      <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
        <h3 style={{ margin: 0 }}>End-to-End System Test</h3>
        <p>
          Prior to running this test, make sure your sim machine is running in:
          OrchTest_JobTest_SesTest/ADT_460_test1/
        </p>

        <Button onClick={runTest} disabled={testStatus === "RUNNING"}>
          {testStatus === "RUNNING" ? "Running Test..." : "Run Full System Test"}
        </Button>

        {testStatus !== "IDLE" && (
          <div
            style={{
              marginTop: "15px",
              padding: "10px",
              border: "1px solid #ccc",
              borderRadius: "4px",
              backgroundColor:
                testStatus === "PASS"
                  ? "rgba(0, 255, 0, 0.1)"
                  : testStatus === "FAIL"
                    ? "rgba(255, 0, 0, 0.1)"
                    : "#f9f9f9",
            }}
          >
            <h4 style={{ margin: "0 0 10px 0" }}>
              Status:{" "}
              <span
                style={{
                  fontWeight: "bold",
                  color: testStatus === "PASS" ? "green" : testStatus === "FAIL" ? "red" : "blue",
                }}
              >
                {testStatus}
              </span>
            </h4>

            <div style={{ marginBottom: "10px" }}>
              <h5>Results breakdown:</h5>
              <ul style={{ listStyle: "none", paddingLeft: 0 }}>
                {results.map((res, idx) => (
                  <li
                    key={idx}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      borderBottom: "1px solid #eee",
                      padding: "5px 0",
                    }}
                  >
                    <span>{res.step}</span>
                    <span>
                      <span style={{ marginRight: "15px" }}>{res.latency.toFixed(2)} ms</span>
                      <span
                        style={{
                          color: res.status === "PASS" ? "green" : "red",
                          fontWeight: "bold",
                        }}
                      >
                        {res.status}
                      </span>
                    </span>
                  </li>
                ))}
              </ul>
            </div>

            <div
              style={{
                maxHeight: "150px",
                overflowY: "auto",
                fontSize: "12px",
                fontFamily: "monospace",
                borderTop: "1px solid #eee",
                paddingTop: "5px",
              }}
            >
              {logs.map((l, i) => (
                <div key={i}>{l}</div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default EndToEndTest;
